export const GetAppConfig = (): { baseApiPath: string } => {
    return {
        baseApiPath: global.BASE_API_URL ?? "https://devapi.harmony.co.id"
    }
}